<div style="height: calc(100vh - 120px);">
    <k-flex-side-nav-container (toggleEvent)="handleSideBarToggle($event)"
     [sideBarOpen]="true">
        <k-flex-side-nav-sidebar>
            <div class="logo-container" *ngIf="isSideBarOpen">
                <img src="../../../../../assets/images/iqLogo.png" width="100px" height="100px" />
            </div>
            <k-flex-side-nav [navItems]="navItems"></k-flex-side-nav>
        </k-flex-side-nav-sidebar>
  
        <k-flex-side-nav-content>
            <router-outlet></router-outlet>
        </k-flex-side-nav-content>
  
    </k-flex-side-nav-container>
</div>